import { Alert, Stack, Typography } from "@mui/material";

interface Props {
  error: string | undefined;
  hasPreviousResult: boolean;
}

const ReportRefreshError = ({ error, hasPreviousResult }: Props) => {
  if (!error) {
    return null;
  }
  return (
    <Alert severity="error" sx={{ mb: 1, flexShrink: 0 }}>
      <Stack>
        {hasPreviousResult && <Typography>Refresh failed. Showing the previous result.</Typography>}
        <Typography>{error}</Typography>
      </Stack>
    </Alert>
  );
};

export default ReportRefreshError;
